
<!--
 * @Author: 仙道
 * @Date: 2022-06-15 21:12:36
 * @LastEditTime: 2022-06-18 11:01:20
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/modules/components/AccountParams.vue
-->
<template>
  <div class="c-tabs-panel">
    <dev-params-list :deviceData="deviceData" />
  </div>
</template>

<script>
  import DevParamsList from '../../vue/DevParamList.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'AccountParams',
    components: {
      DevParamsList
    },
    props: {
      deviceData: {
        type: Object,
        default: () => { }
      }
    },
    // 定义属性
    data () {
      return {

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

    }
  }
</script>

<style lang='scss' scoped>


</style>
